import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  Output,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { DocumentsDialog } from '../../documents-dialog/documents-dialog.component';
import { CommentsComponent } from '../../comments/comments.component';
import { NotesComponent } from '../../notes-dialog/notes.component';
import { MapmodalDialogComponent } from '../../mapmodal-dialog/mapmodal-dialog.component';
import { FormsModule } from '@angular/forms';
import { CommonUtilityServiceService } from '../../services/common-utility-service.service';
import { ModalService } from '../../services/modal.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExpensesDialogComponent } from '../../expenses-dialog/expenses-dialog.component';

@Component({
  selector: 'project-history-table-row',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    DocumentsDialog,
    CommentsComponent,
    NotesComponent,
    MapmodalDialogComponent,
    FormsModule,
    MatTooltipModule,
    ExpensesDialogComponent,
  ],
  templateUrl: './project-history-table-row.component.html',
  styleUrl: './project-history-table-row.component.scss',
})
export class ProjectHistoryTableRowComponent {
  @Input() data: any = '';
  @Input() id: string = '';
  @Input() status: string = '';
  @Input() site: number = 0;
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() acreage: number = 0;
  @Input() landUse: string = '';
  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() dueDate: string = '';
  @Input() turnTime: number = 0;
  @Input() deliveryDate: any = '';
  @Input() bidAmount: number = 0;
  @Input() reviewStatus: string = '';
  @Input() type: string = '';
  @Input() showStatus: boolean = true;
  @Input() showSite: boolean = true;
  @Input() showAddress: boolean = true;
  @Input() showAcreage: boolean = true;
  @Input() showLandUse: boolean = true;
  @Input() showSiteType: boolean = true;
  @Input() showDueDate: boolean = true;
  @Input() showActions: boolean = true;
  @Input() showSiteRequirements: boolean = true;
  @Input() bidNotes: string = '';
  @Input() rowIndex: number = 0;

  @Output() handleSiteUpdate = new EventEmitter<any>();
  @Output() handleUpdateDocuments = new EventEmitter<any>();

  tableA: string = '';
  documentsActive: boolean = false;
  editToggle: boolean = false;
  isDeclineActive: boolean = false;
  submitForReviewActive: boolean = false;
  commentsActive: boolean = false;
  notesActive: boolean = false;
  savedActive: boolean = false;
  mapActive: boolean = false;
  expensesActive: boolean = false;
  showReviewSubmission: boolean = false;
  showRevisionSubmission: boolean = false;
  isAlta: boolean = false;
  selectedSiteType: string = '';
  selectedSiteId: string = '';
  containsItem21: boolean = false;
  currentBidAmount: number = 0;
  currentTurnTime: number = 0;
  documents: any = [];

  constructor(
    private utilityService: CommonUtilityServiceService,
    private modalService: ModalService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  ngOnInit() {
    this.address = this.utilityService.formatAddress(this.data);
    this.containsItem21 = this.data.site.tableA?.some(
      (item: any) => item.itemName === '21'
    );
    let response = this.utilityService.formatTableA(
      this.data,
      this.containsItem21
    );
    if (response) {
      this.tableA = response[1];
    }
    this.currentTurnTime = this.data.proposal.proposedTurnTime;
    this.currentBidAmount = this.data.proposal.bid;
    this.isAlta = this.data.site.serviceType === 'NEXUS_ALTA_SURVEY';

    let documents: any = [];
    if (this.data.site.documents) {
      documents = [...documents, ...this.data.site.documents];
    }
    if (this.data.proposal.documents) {
      documents = [...documents, ...this.data.proposal.documents];
      this.showReviewSubmission = this.data.proposal.documents.some(
        (document: { type: string }) => document.type === 'DELIVERABLE'
      );
      this.showRevisionSubmission = this.data.proposal.documents.some(
        (document: { type: string }) => document.type === 'REVISION'
      );
    }
    this.documents = documents;
    this.modalService.isDocumentModalOpen.subscribe((open) => {
      if (this.data.site.id === open.siteId) {
        this.documentsActive = open.isOpen;
      }
    });
  }

  toggleCommentsModal() {
    this.commentsActive = !this.commentsActive;
  }

  toggleNotesModal() {
    this.notesActive = !this.notesActive;
  }

  toggleOpenDocumentsModal() {
    this.documentsActive = true;
    this.modalService.toogleOpenDocumentModal(this.data.site.id);
  }

  toggleCloseDocumentsModal() {
    this.documentsActive = false;
    this.modalService.toogleCloseDocumentModal();
  }

  toggleDeclineModal() {
    this.isDeclineActive = !this.isDeclineActive;
  }

  toggleMapModal(siteType: string, siteId: string) {
    this.mapActive = !this.mapActive;
    this.selectedSiteType = siteType;
    this.selectedSiteId = siteId;
  }

  toggleOpenExpensesModal() {
    this.expensesActive = true;
  }

  toggleCloseExpensesModal() {
    this.expensesActive = false;
  }

  saveBidNote(event: { fieldName: String; value: any }) {
    this.handleSiteUpdate.emit({
      siteId: this.id,
      fieldName: event.fieldName,
      value: event.value,
    });
  }

  updateDocuments(event: { siteDetail: any }) {
    this.handleUpdateDocuments.emit({ updatedSiteDetail: event.siteDetail });
  }

  getFullSiteReqTooltip(): string {
    const parts: string[] = [];
    if (this.data?.site?.tableAChanges) {
      const changes = this.data.site.tableAChanges;
      if (changes.itemsAdded || changes.itemsRemoved) {
        let tableAPart = 'Table A: ';
        if (changes.itemsAdded) tableAPart += '+ ' + changes.itemsAdded;
        if (changes.itemsAdded && changes.itemsRemoved) tableAPart += ' · ';
        if (changes.itemsRemoved) tableAPart += '− ' + changes.itemsRemoved;
        parts.push(tableAPart);
      }
    }
    if (this.data?.site?.specialSiteCondition) {
      parts.push(this.data.site.specialSiteCondition);
    }
    const full = parts.join('\n');
    return full.length > 100 ? full : '';
  }
}
